<template>
  <section>
    <el-dialog
      :close-on-click-modal="false"
      title="查看GPS费"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="800px"
    >
      <section class="dialogContent">
        <qx-detail-box :data="detailData.base">
          <section slot="detailPic">
            <template v-if="originData.detailPic && originData.detailPic.length">
              <span
                class="detail-img-box"
                v-for="(item, index) in originData.detailPic"
                :key="index"
                @click="previewImg(item.url)"
              >
                <img class="detail-img" :src="item.url" />
              </span>
            </template>
            <span v-else>--</span>
          </section>
        </qx-detail-box>
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="customFormPost"
          :loading="subLoading || getDetailLoading"
        >确 定</el-button>
      </section>
    </el-dialog>
  </section>
</template>

<script>
export default {
  props: {
    orgId: {
      type: Number,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              { prop: 'plateNumber', label: '车牌号码' },
              { prop: 'licenceTypeName', label: '牌照类型' },
              { prop: 'suitTypeName', label: '套装类型' },
              { prop: 'serviveLoseDate', label: '服务失效日期' },
              { prop: 'equipmentNumber', label: '设备号' },
              { prop: 'feeAscriptionDate', label: '费用日期' },
              { prop: 'suitFee', label: '套装费用', unit: '元', span: 1 },
              { prop: 'detailPic', label: '附件', slot: true, span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  methods: {
    previewImg (url) {
      this.$emit('previewImg', url);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;

        this.detailData.base.tableData.data = {
          plateNumber: item.plateNumber,
          licenceTypeName: item.licenceTypeName,
          suitTypeName: item.suitTypeName,
          serviveLoseDate: item.serviveLoseDate,
          equipmentNumber: item.equipmentNumber,
          feeAscriptionDate: item.feeAscriptionDate,
          suitFee: item.suitFee,
        };

      });
    },

    customFormPost () {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.detail-img-box {
  display: inline-block;
  margin-right: 8px;
  width: 80px;
  margin-top: 15px;
  .detail-img {
    display: block;
    width: 100%;
    cursor: pointer;
  }
}
</style>

